import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper, ButtonLabel } from './styles';
import IconFont from '../IconFont';

const CorriereLink = ({
  background,
  label,
  color,
  linkTo,
  borderColor,
  width,
  isTitleNarrowMedium,
  margin,
  isBottomLink,
  visibility,
}) => (
  <ButtonWrapper
    background={background}
    href={linkTo}
    borderColor={borderColor}
    width={width}
    margin={margin}
    visibility={visibility}
  >
    <ButtonLabel
      color={color}
      isTitleNarrowMedium={isTitleNarrowMedium}
      className="flex justifyContentEnd alignItemsCenter"
      isBottomLink={isBottomLink}
    >
      <span>
        {label}
      </span>
      {!isBottomLink &&
        <IconFont
          className="icon-matchcenter-arrow-small"
          font={4}
          marginLeft={1}
          marginBottom={0.5}
          color="lightBlue2"
        />
      }
    </ButtonLabel>
  </ButtonWrapper>
);

CorriereLink.propTypes = {
  label: PropTypes.string,
  color: PropTypes.any,
  background: PropTypes.any,
  linkTo: PropTypes.any,
  borderColor: PropTypes.any,
  width: PropTypes.string,
  isTitleNarrowMedium: PropTypes.bool,
  margin: PropTypes.string,
  isBottomLink: PropTypes.bool,
  visibility: PropTypes.string,
};

export default CorriereLink;



// WEBPACK FOOTER //
// ./src/components/shared/CorriereLink/index.js